import { z } from 'zod';

import type { IdContactDto } from '@/services/ws-crm/src/main/resources/rest-api';
import type { IdSalesPromotionDto, LanguageCode } from '@/services/ws-funnel/src/main/resources/rest-api';

import { SEARCH_KEY_CONTACT_IDS } from '../constants.ts';

export interface PromotionMailRouteParams {
  promotionId: IdSalesPromotionDto;
}

export interface UploadFile {
  id: string;
  file: File;
  language: LanguageCode;
}

export const PromotionMailSearchParams = z.object({
  [SEARCH_KEY_CONTACT_IDS]: z.array(z.custom<IdContactDto>()).optional(),
});
